













































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IMatrix } from '@/misc';
import MatrixCode from '@/components/MatrixCode.vue';
import MatrixTable from '@/components/MatrixTable.vue';

export enum TabName {
  hide = 'hide',
  code = 'code',
  table = 'table',
  presets = 'presets',
  references = 'references',
}
export const defaultTabName = TabName.code;

@Component({
  components: {
    MatrixCode,
    MatrixTable,
  },
})
export default class HomeFloatingPanel extends Vue {
  @Prop() protected matrix!: IMatrix;
  @Prop() protected onPreset!: (data: { matrix: IMatrix }) => void;
  @Prop() protected curTab!: TabName;
  @Prop() protected onTabChange!: (data: { name: TabName }) => void;

  protected defaultTabName = defaultTabName;

  public tabButton_onClick(event: MouseEvent) {
    const el = event.currentTarget as HTMLSpanElement;
    const name = el.getAttribute('data-name') as TabName; // :)
    this.onTabChange({ name });
  }

  public initial_onClick() {
    this.onPreset({
      matrix: {
        ix: 1, iy: 0,
        jx: 0, jy: 1,
        tx: 0, ty: 0,
      },
    });
  }

  public rotate_onClick() {
    this.onPreset({
      matrix: {
        ix: this.cos(30), iy: this.sin(30),
        jx: this.cos(90 + 30), jy: this.sin(90 + 30),
        tx: 0, ty: 0,
      },
    });
  }

  public flip_onClick() {
    this.onPreset({
      matrix: {
        ix: -1, iy: 0,
        jx: 0, jy: 1,
        tx: 100, ty: 0,
      },
    });
  }

  public larger_onClick() {
    this.onPreset({
      matrix: {
        ix: 2, iy: 0,
        jx: 0, jy: 2,
        tx: 0, ty: 0,
      },
    });
  }

  public skew_onClick() {
    this.onPreset({
      matrix: {
        ix: 1, iy: 0,
        jx: this.sin(30), jy: 1,
        tx: 0, ty: 0,
      },
    });
  }

  protected cos(deg: number) {
    return Math.cos(deg / 360 * Math.PI * 2);
  }

  protected sin(deg: number) {
    return Math.sin(deg / 360 * Math.PI * 2);
  }
}
